import { MijnRoute } from '../../mijn-navigatie.model';

export const PENSION_EXPANSION_REQUEST_DEPOSIT: MijnRoute = {
    path: 'pensioen-uitbreiding-aanvragen/deposito',
    navigationEvent: 'toPensionExpansionRequestDeposit',
    regex: /^\/pensioen-uitbreiding-aanvragen\/deposito$/,
    webcomponent: 'my-pension-expansion-request-webcomponent'
};
